module.exports = __webpack_public_path__ + "static/media/vehicle-registration.ff4e35a6.png";